'use strict';

wbApp.controller('ActionsStudentsAttendanceDetailCtrl', ['$scope', 'attendanceSvc',
function ($scope, attendanceSvc) {

    $scope.isSaving = false;
    $scope.isBusy = true;

    var model = null;

    var attendance = attendanceSvc.getStudentCourseAttendance($scope.courseID, $scope.studentID)
        .$promise.then(function (atts) {
            $scope.isBusy = false;

            if (atts.length > 0) {
                $scope.model = atts[0];
                $scope.modelOrig = angular.copy($scope.model);
            }
    });

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        function success() {
            $scope.onAfterSuccessSave();
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }

        function cancel() {
            $scope.isSaving = false;
        }

        attendanceSvc.update(model, null, success, error);
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };
}]);
